import { $authHost } from "../../http";
import { 
    AN_OBJECT_SUB_SECTION_GET_REQUEST, AN_OBJECT_SUB_SECTION_GET_SUCCESS, AN_OBJECT_SUB_SECTION_GET_ERROR, 
    AN_OBJECT_SUB_SECTION_GET_BY_KEY_REQUEST, AN_OBJECT_SUB_SECTION_GET_BY_KEY_SUCCESS, AN_OBJECT_SUB_SECTION_GET_BY_KEY_ERROR, 
    AN_OBJECT_SUB_SECTION_ADD_REQUEST, AN_OBJECT_SUB_SECTION_ADD_SUCCESS, AN_OBJECT_SUB_SECTION_ADD_ERROR, 
    AN_OBJECT_SUB_SECTION_EDIT_REQUEST, AN_OBJECT_SUB_SECTION_EDIT_SUCCESS, AN_OBJECT_SUB_SECTION_EDIT_ERROR, 
    AN_OBJECT_SUB_SECTION_DELETE_REQUEST, AN_OBJECT_SUB_SECTION_DELETE_SUCCESS, AN_OBJECT_SUB_SECTION_DELETE_ERROR
} from "../constants/anObjectSubSectionConstants";

export const getAnObjectSubSections = (args) => async (dispatch) => {
    try {
        dispatch({
            type: AN_OBJECT_SUB_SECTION_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/anObjectSubSection/query",
            args || {},
            config,
        );
        dispatch({
            type: AN_OBJECT_SUB_SECTION_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: AN_OBJECT_SUB_SECTION_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getAnObjectSubSectionByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: AN_OBJECT_SUB_SECTION_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/anObjectSubSection/${id}`,
        );
        dispatch({
            type: AN_OBJECT_SUB_SECTION_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: AN_OBJECT_SUB_SECTION_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addAnObjectSubSection = ({ name, description, sectionId }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: AN_OBJECT_SUB_SECTION_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/anObjectSubSection",
            { name, description, sectionId },
            config,
        );
        dispatch(getAnObjectSubSections(queryArgs || {}));
        dispatch({
            type: AN_OBJECT_SUB_SECTION_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: AN_OBJECT_SUB_SECTION_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editAnObjectSubSection = ({ id, name, description, sectionId }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: AN_OBJECT_SUB_SECTION_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/anObjectSubSection",
            { id, name, description, sectionId },
            config,
        );
        dispatch(getAnObjectSubSections(queryArgs || {}));
        dispatch({
            type: AN_OBJECT_SUB_SECTION_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: AN_OBJECT_SUB_SECTION_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteAnObjectSubSection = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: AN_OBJECT_SUB_SECTION_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/anObjectSubSection",
            { data: { id } },
            config,
        );
        dispatch(getAnObjectSubSections(queryArgs || {}));
        dispatch({
            type: AN_OBJECT_SUB_SECTION_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: AN_OBJECT_SUB_SECTION_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

